import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import BathroomRemodeling from "@/pages/BathroomRemodeling";
import TubShowerConversions from "@/pages/TubShowerConversions";
import WalkInTubs from "@/pages/WalkInTubs";
import Scheduling from "@/pages/Scheduling";

function App() {
  return (
    <div className="min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BathroomRemodeling />} />
          <Route path="/bathroom-remodeling" element={<BathroomRemodeling />} />
          <Route path="/tub-shower-conversions" element={<TubShowerConversions />} />
          <Route path="/walk-in-tubs" element={<WalkInTubs />} />
          <Route path="/scheduling" element={<Scheduling />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
